let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8SMhH")).then(() => parcelRequire('d8nfK'));